import type { User } from '@/entities/user';
import type { RemoteAuthUser } from './remoteAuthTypes';
import { resolveDashboardRole } from './resolveDashboardRole';

/**
 * Maps backend `roles[]` (platform + role) into the dashboard `Role` union.
 */
export function mapRemoteAuthUserToUser(api: RemoteAuthUser): User {
  const role = resolveDashboardRole(api);

  return {
    id: api.id,
    username: api.email,
    name: displayNameFromEmail(api.email),
    role,
    storeIds: resolveStoreIds(api),
  };
}

function resolveStoreIds(api: RemoteAuthUser): string[] {
  if (api.storeIds?.length) {
    return api.storeIds.filter((id) => typeof id === 'string' && id.length > 0);
  }
  if (api.assignedStoreIds?.length) {
    return api.assignedStoreIds.filter((id) => typeof id === 'string' && id.length > 0);
  }
  if (api.stores?.length) {
    return api.stores.map((s) => s.id).filter((id) => typeof id === 'string' && id.length > 0);
  }
  return [];
}

function displayNameFromEmail(email: string): string {
  const local = email.split('@')[0] ?? email;
  return local.replace(/[._-]+/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}
